import React from 'react'
import './sidebar.scss'


const SunIcon = () => {
    return (


        <svg className='sun-moon' id="sun-icon" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 214.78 214.78">

            <circle className="sun-path" cx="107.39" cy="107.39" r="54" />
            <rect className="sun-path" x="101.86" width="11.07" height="34.43" />
            <rect className="sun-path" x="38.09" y="26.41" width="11.07" height="34.43" transform="translate(-18.07 43.63) rotate(-45)" />
            <rect className="sun-path" x="11.68" y="90.17" width="11.07" height="34.43" transform="translate(-90.17 124.61) rotate(-90)" />
            <rect className="sun-path" x="38.09" y="153.94" width="11.07" height="34.43" transform="translate(-46.55 323.03) rotate(-135)" />
            <rect className="sun-path" x="101.86" y="180.35" width="11.07" height="34.43" transform="translate(214.78 395.13) rotate(-180)" />
            <rect className="sun-path" x="165.62" y="153.94" width="11.07" height="34.43" transform="translate(413.2 171.15) rotate(135)" />
            <rect className="sun-path" x="192.03" y="90.17" width="11.07" height="34.43" transform="translate(304.96 -90.17) rotate(90)" />
            <rect className="sun-path" x="165.62" y="26.41" width="11.07" height="34.43" transform="translate(80.98 -108.25) rotate(45)" />
        </svg>
    )
}

export default SunIcon
